import { Avatar, SxProps, useTheme } from '@mui/material';
import { athleteInitials, AthletePreview } from '@strength/domain';

export const AthleteAvatar = ({
  athlete,
  imgSrc,
  onClick,
  sx,
}: {
  athlete: Pick<AthletePreview, 'givenName' | 'familyName'>;
  imgSrc?: string;
  onClick?: () => void;
  sx?: SxProps;
}) => {
  const {
    palette: { greyscaleLight },
  } = useTheme();

  return (
    <Avatar
      sx={{ bgcolor: greyscaleLight[500], fontWeight: 'semibold', ...sx }}
      src={imgSrc}
      onClick={onClick ? () => onClick() : undefined}
    >
      {athleteInitials(athlete)}
    </Avatar>
  );
};
